export default import.meta.env.MODE;
